export class AdminConfigurationController {

    constructor() {
        var AdminConfiguration = this;
        AdminConfiguration.stateUrl = '/configuration';
        AdminConfiguration.controllerName = 'idan'

    }
}


// WEBPACK FOOTER //
// ./states/admin/configuration/configuration.controller.js